import React from 'react';
import { Typography } from '@mui/material';

type OverviewTextProps = {
  text: string;
};

export const OverviewText: React.FC<OverviewTextProps> = ({ text }) => (
  <Typography sx={{ color: 'var(--color-type-secondary)', marginBottom: 3 }}>{text}</Typography>
);
